import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  loader: false,
  getList: false,
  alertMsg: '',
  questionsList: [],
  selectedQuestions: [],
  reportName: ''
};

const questionSlice = createSlice({
  name: 'questions',
  initialState: INITIAL_STATE,
  reducers: {
    getQuestionList(state) {
      state.loader = true;
      state.getList = false;
    },
    setQuestions(state, { payload }) {
      state.loader = false;
      state.getList = true;
      state.questionsList = payload;
    },
    startLoading(state) {
      state.loader = true;
      state.getList = false;
    },
    stopLoading(state) {
      state.loader = false;
    },

    resetStateOnUnmount(state) {
      state.getList = false;
      state.alertMsg = '';
    },
    setSelectedQuestions(state, { payload }) {
      state.selectedQuestions = payload;
    },
    setReportName(state, { payload }) {
      state.reportName = payload;
    }
  }
});

export const questionAction = questionSlice.actions;

export default questionSlice.reducer;
